import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function Header({ minimal = false }) {
  const { pathname } = useLocation();
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 backdrop-blur-xl bg-white/85 border-b border-stone-200/70"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-3">
        <Link to="/" data-testid="header-logo-link" className="flex items-center gap-2.5 group min-w-0">
          <div className="w-10 h-10 sm:w-11 sm:h-11 rounded-xl bg-ink-900 flex items-center justify-center shadow-sm group-hover:shadow-md transition-all overflow-hidden p-1 ring-1 ring-stone-900/10">
            <img
              src="/atmia-logo.png"
              alt="Atmia Education logo"
              className="w-full h-full object-contain group-hover:scale-105 transition-transform"
            />
          </div>
          <div className="leading-tight min-w-0">
            <div className="font-serif text-base sm:text-lg text-stone-900 truncate">Atmia Education</div>
            <div className="text-[9px] sm:text-[10px] uppercase tracking-[0.18em] text-saffron-600 font-medium truncate">
              Guiding Future Doctors
            </div>
          </div>
        </Link>
        {!minimal && (
          <nav className="hidden md:flex items-center gap-7 text-sm">
            <a href="#about" data-testid="nav-about" className="text-stone-600 hover:text-saffron-600 transition-colors">About</a>
            <a href="#services" data-testid="nav-services" className="text-stone-600 hover:text-saffron-600 transition-colors">Services</a>
            <a href="#university" data-testid="nav-university" className="text-stone-600 hover:text-saffron-600 transition-colors">University</a>
            <a href="#feedback" data-testid="nav-feedback" className="text-stone-600 hover:text-saffron-600 transition-colors">Feedback</a>
          </nav>
        )}
        <Link
          to={pathname === "/feedback" ? "/" : "/feedback"}
          data-testid="header-cta-button"
          className="inline-flex shrink-0 items-center bg-saffron-500 hover:bg-saffron-600 text-white rounded-full px-3.5 sm:px-5 py-2 text-xs sm:text-sm font-medium shadow-sm hover:shadow-md transition-all btn-shine"
        >
          <span className="hidden sm:inline">{pathname === "/feedback" ? "Back to Home" : "Share Feedback"}</span>
          <span className="sm:hidden">{pathname === "/feedback" ? "Home" : "Feedback"}</span>
        </Link>
      </div>
    </header>
  );
}
